<div class="on-row-hover" [ngStyle]="{'width': width}">{{data.value}}</div>
